module.exports = __webpack_public_path__ + "static/media/logo.5bba9923.svg";